export default __webpack_public_path__ + "static/media/dispersal-vector-agents.13448a48.png";